<template>
  <v-card class="mx-auto my-8" max-width="80%" height="auto" elevation="16">
    <p class="txtinfo" align="center">Nuestras Sucursales</p>
    <divider-component />

    <v-card-text align="center" class="txtdescripciones">
      Actualmente, contamos con una red de seis sucursales estratégicamente
      ubicadas en dos estados: Hidalgo y Oaxaca. Nuestras sucursales no solo son
      puntos de contacto, sino centros de excelencia que reflejan nuestro
      compromiso con la accesibilidad y la atención personalizada. Estamos
      listos para atenderte y ser tu socio confiable en tu obra. ¡Visítanos y
      experimenta la calidad y el compromiso que solo CASA CRU puede ofrecer!
    </v-card-text>
  </v-card>

  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        lg="6"
        md="6"
        xl="4"
        align="center"
        v-for="(item, index) in Sucursales"
        :key="index"
      >
        <carrusel-sucursales-component
          :Sucursal="item.Sucursal"
          :Descripcion="item.Descripcion"
          :Ubicacion="item.Ubicacion"
          :Telefono="item.Telefono"
          :Foto="item.Foto"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DividerComponent from '@/components/DividerComponent.vue';
import CarruselSucursalesComponent from '@/components/CarruselSucursalesComponent.vue';
export default {
  data() {
    return {
      Sucursales: [
        {
          Sucursal: 'SUCURSAL DENGUI, HGO',
          Descripcion:
            'Independencia SN, Independencia, Dengui, 42840 San Miguel Vindho, Hgo.',
          Ubicacion:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7498.382042488072!2d-99.34195130838741!3d20.000495975615202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d22d6cb67c8117%3A0x6dce5ebcf40174f9!2sCasa%20Cru%20S.A.%20de%20C.V.!5e0!3m2!1ses!2smx!4v1705260670616!5m2!1ses!2smx',
          Telefono: '(773) 785-1885',
          Foto: 'sucursal_Dengui.webp',
        },
        {
          Sucursal: 'SUCURSAL EL 61, HGO',
          Descripcion: 'HGO 17 113, 42836 Hgo.',
          Ubicacion:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7498.382042488072!2d-99.34195130838741!3d20.000495975615202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d22dc217d10805%3A0xf6b6c9e5f37847b7!2sCasa%20Cru%20Sucursal%2061!5e0!3m2!1ses!2smx!4v1705260752195!5m2!1ses!2smx',
          Telefono: '(773) 724-1265',
          Foto: 'sucursal_61.webp',
        },
        {
          Sucursal: 'SUCURSAL LAGUNAS, OAX',
          Descripcion: '70380, Fracc. Las Flores, 70380 Oax.',
          Ubicacion:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3819.5283408722175!2d-95.09231202101225!3d16.800125642710476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c01e4cedfd34e1%3A0x7e0fc673375442b0!2sCasa%20Cru%20Lagunas%2C%20Oaxaca!5e0!3m2!1ses!2smx!4v1705260808716!5m2!1ses!2smx',
          Telefono: '(972) 726-1096',
          Foto: 'sucursal_Lagunas.webp',
        },
        {
          Sucursal: 'SUCURSAL NOPALA, Hgo',
          Descripcion: 'Nopala de Villagrán, Hidalgo',
          Ubicacion:
            'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1688.844312722132!2d-99.63503688728709!3d20.245147804593273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2smx!4v1706539208114!5m2!1ses!2smx',
          Telefono: '(972) 726-1096',
          Foto: 'sucursal_nopala.webp',
        },
        {
          Sucursal: 'SUCURSAL MATIAS ROMERO, OAX.',
          Descripcion:
            'Guerrero 404, Juarez Nte., 70300 Matías Romero Avendaño, Oax.',
          Ubicacion:
            'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3817.9933767521434!2d-95.04218602497723!3d16.876222183926426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTbCsDUyJzM0LjQiTiA5NcKwMDInMjIuNiJX!5e0!3m2!1ses!2smx!4v1706539379920!5m2!1ses!2smx',
          Telefono: '(972) 726-1096',
          Foto: 'sucursal-matias-romaero.webp',
        },
      ],
    };
  },

  components: { DividerComponent, CarruselSucursalesComponent },
};
</script>

<style scope>
.txtinfo {
  padding-top: 2rem;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: 800;
  color: #1c3e8e;
  line-height: 1;
}
.txtdescripciones {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  color: black;
  padding-left: 1rem;
  padding-right: 2rem;
}
</style>
